<template>
  <!-- report comment -->
  <Modal
    :isOpen="isOpen"
    :changeModalState="changeModalState"
    modalClass="report_comment"
    :disableScrolling="true"
    :modalTitle="$t('user.report_comment_noun')"
    centeredTitle
    smallTitle
    :size="'xl'"
    :hideHeadersBorder="true"
  >
      <div
        class="relative pb-6 md:pb-7 px-4 md:px-6 lg:px-8 xl:px-10 2xl:px-12 3xl:px-13 overscroll-none overflow-y-auto min-h-[calc(15vh)] max-h-[80vh]"
      >
        <div class="relative">

          <!-- rate form -->
          <form
            ref="provideFeedbackFormRef"
            class="flex flex-col p-0 mt-[-5px]`.trim()"
            @submit.prevent="() => makeAReport()"
          >

            <textarea
              :disabled="isProcessing"
              v-model="rateForm.comment"
              class="border border-[#D8D8D8] placeholder:text-[#C8C8C8] rounded-[7px] duration-200 mt-6 min-h-[75px] md:min-h-[90px] max-h-[150px] w-full"
              :placeholder="''"
            />
            <!-- error -->
              <div
                v-if="v$ && v$.rateForm && v$.rateForm.comment && v$.rateForm.comment.$errors">
                <p v-for="(error) of v$.rateForm.comment.$errors" :key="error.uid"
                  class="error_message p-4 mb-4 flex flex-column text-sm mt-4 text-red-800 rounded-lg bg-red-50"
                  role="alert">{{ error.$message}}</p>
              </div>
            <!-- submit form button -->
            <div class="flex justify-center mt-0 md:mt-1 lg:mt-2">
              <input
                :class="
                  `${
                    isProcessing ? 'disabled' : ''
                  } max-w-[310px] md:max-w-[320px] 3xl:max-w-[326px] w-full bg-[#0963FF] hover:bg-[#0963FF]/90 transition-colors duration-150 cursor-pointer text-white mt-3 font-bold py-[0.525rem] px-6 sm:px-10 md:px-12 text-[15px] sm:text-[16px] md:text-[17px] lg:text-[18px] rounded-[7px]`.trim()
                "
                type="submit"
                :value="
                  isProcessing ? $t('general.loading') : $t('general.report')
                "
              />
            </div>
          </form>
        </div>
      </div>
  </Modal>
</template>

<script>
import { Modal } from "@/components";
import useVuelidate from '@vuelidate/core';

export default {
  data(){
    return {
      v$: useVuelidate(),
      rateForm: {
        comment: "",
      },
      hasSubmitted: false,
      previousProcessingState: false,
    }
  },
  validations(){
    return {
      rateForm: {
        comment: this.VALIDATIONS.reportDescription
      },
    }
  },
  props: {
    isProcessing: {
      type: Boolean,
      default: false,
      required: true,
    },
    isOpen: {
      type: Boolean,
      default: false,
      required: true,
    },
    changeModalState: {
      type: Function,
      required: true,
    },
    confirmReportingRate: {
        type: Function,
        required: true,
    },
    commentToReportObj: {
        type: [Object, null],
        required: true, 
        default: () => ({}),
    }
  },
  components: {
    Modal,
  },
  watch: {
    isProcessing(newVal, oldVal) {
      // When processing completes (goes from true to false) after submission, close the modal
      if (oldVal === true && newVal === false && this.hasSubmitted && this.isOpen) {
        this.changeModalState(false);
      }
      this.previousProcessingState = newVal;
    },
    isOpen(newVal) {
      // When modal closes, clear the form and reset validation
      if (newVal === false) {
        this.resetForm();
      } else if (newVal === true) {
        // Reset submission flag when modal opens
        this.hasSubmitted = false;
      }
    }
  },
  methods: {
    makeAReport(){
        this.v$.$touch();
        if (this.v$.rateForm.$error) return;
        this.hasSubmitted = true;
        this.confirmReportingRate?.({rateForm: this.rateForm, item: this.commentToReportObj});
    },
    resetForm() {
      this.rateForm.comment = "";
      this.hasSubmitted = false;
      // Reset validation state
      if (this.v$) {
        this.v$.$reset();
      }
    }
  }
};
</script>

<style></style>
